
import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "./context/UserContext";

const PrivateRoute = ({ children }) => {
  const { loggedInUser, loading } = useUser();

  if (loading) return null; // or return a loader/spinner

  return loggedInUser ? children : <Navigate to="/" />;
};

export default PrivateRoute;
